import { formatClock } from '../../shared/format';
import type { ActiveJoker, AuthorSeat, PublicRound } from '../../shared/types';

/**
 * Active jokers with their live wall-clock countdown (C1). Shown on every
 * view; the projection uses size L. `clockOffset` aligns the server's
 * endsAt deadline with the local clock.
 */
export function JokerBanner(props: {
  round: PublicRound;
  authors: AuthorSeat[];
  now: number;
  clockOffset: number;
  size?: 'M' | 'L';
  onEnd?: (instanceId: string) => void;
}) {
  const { round, authors, now, clockOffset, size = 'M', onEnd } = props;
  if (round.activeJokers.length === 0) return null;

  const remaining = (j: ActiveJoker): number | null => {
    if (j.remainingMsAtPause !== null) return j.remainingMsAtPause;
    if (j.endsAt === null) return null;
    return Math.max(0, j.endsAt - (now + clockOffset));
  };

  const targetLabel = (j: ActiveJoker): string =>
    j.target === 'global' ? 'BEIDE' : (authors[j.target]?.name ?? `Autor:in ${j.target + 1}`).toUpperCase();

  return (
    <div className={`jokers jokers--${size}`} data-testid="joker-banner">
      {round.activeJokers.map((j) => {
        const ms = remaining(j);
        return (
          <div key={j.instanceId} className="joker" data-testid="joker-active">
            <span className="joker__tag">JOKER · {targetLabel(j)}</span>
            <span className="joker__name">{j.name}</span>
            {j.desc && size === 'L' && <span className="joker__desc">{j.desc}</span>}
            <span className="joker__time">{ms === null ? '∞' : formatClock(ms)}</span>
            {onEnd && (
              <button className="btn btn--ghost btn--small" onClick={() => onEnd(j.instanceId)}>
                Beenden
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}
